var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.875 5.375V8.125M6.625 5.375V8.125M4.375 3.875V3.375C4.375 2.82272 4.82272 2.375 5.375 2.375H6.125C6.67728 2.375 7.125 2.82272 7.125 3.375V3.875M2.375 3.875H9.125M3.29558 8.71163L2.875 3.875H8.625L8.20442 8.71163C8.15949 9.22839 7.72689 9.625 7.20818 9.625H4.29182C3.77311 9.625 3.34051 9.22839 3.29558 8.71163Z",
    stroke: "#2D2D38",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d28f7260.svg";
export { ForwardRef as ReactComponent };